<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body flex flex_gap_10">
        <div>
          <label>Период</label>
          <div>
            <DateRangePicker ref="range"/>
          </div>
        </div>
        <div>
          <label>Дивизионы</label>
          <div>
            <Multiselect
              v-model="selectedDivisions"
              :options="getDivision()"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              :custom-label="getDivisionOption"
              placeholder="Выберите дивизионы"
              label="title"
              track-by="id">
              <template slot="noResult">Дивизион не найден</template>
            </Multiselect>
          </div>
        </div>
        <div class="flex-grow-1 text-right">
          <LoadingButton
            title='Показать'
            type="button"
            :loading="btnLoading"
            :color="$constants.LOADING_COLOR"
            :onClick="() => getRecords()"
            className="btn btn-outline-info"
          />
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="btnLoading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div v-if="!btnLoading && Object.keys(records).length">
          <table class="table mt-0 table-hover table-sm">
            <thead>
            <tr>
              <th></th>
              <th>Дивизион</th>
              <th>курьер</th>
              <th>заявок</th>
              <th>зп</th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(group, id, i) in records">
              <tr>
                <td :rowspan="group.length +1">{{ i + 1 }}</td>
                <td :rowspan="group.length + 1">{{ $AllDivisions[group[0].division_id]?.title }}</td>
              </tr>
              <tr v-for="g in group">
                <!--                <td>{{ g }}</td>-->
                <td>{{ g.courier?.short_name ?? g.courier?.name }}</td>
                <td>{{ g.total_orders }}</td>
                <td>{{ Math.round(g.total_salary) }}</td>
              </tr>
            </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateRangePicker from "@/components/dateSelect/DateRangePicker.vue";
import Multiselect from "vue-multiselect";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  components: {
    LoadingButton,
    DateRangePicker,
    Multiselect,
  },
  data() {
    return {
      selectedDivisions: [],
      divisions: [],
      btnLoading: false,
      records: {},
    }
  },
  methods: {
    async getRecords() {
      this.btnLoading = true;
      const {data} = await api.post('/new/divisions/salary', {
        divisions: this.selectedDivisions.map((d) => d.id),
        range: this.$refs.range.getRange()
      });
      if (data.success) {
        this.records = data.records.reduce((acc, r) => {
          if (!acc[r.division_id]) acc[r.division_id] = [];
          acc[r.division_id].push(r);
          return acc;
        }, {});
      } else {
        toastr['warning'](data.message || 'Ошибка получения данных');
      }
      this.btnLoading = false;
    },
    getDivisionOption(e) {
      return e.title + (!e.is_active ? ' (не активен)' : '');
    },
    getDivision() {
      return _.orderBy(Object.values(this.$AllDivisions), 'title');
    }
  }
}

</script>
